import { useGet } from 'restful-react'
import { Button } from './UIComponents2/Button'
import CrossPlatformDialog from './dialogs/components/CrossPlatformDialog'

function AppUpdateNotificationPopup({
    onClose,
    versionData,
}: {
    onClose: (affirmative: boolean, dontAskAgainForThisVersion: boolean) => void
    versionData: { from: string; to: string }
}) {
    const {
        data: releaseNotesData,
        error,
        loading,
    } = useGet({
        path: '/v1/app/release-notes',
        queryParams: { from: versionData.from, to: versionData.to },
    })

    return (
        <CrossPlatformDialog onDefaultClose={() => onClose(false, false)}>
            <div className="px-5">
                <h2 className="text-[32px] font-medium">
                    Update
                    <br />
                    Available
                </h2>
                <div className="my-4">
                    You can update Muse <span style={{ color: '#f9cc04' }}>v{versionData.from}</span> {'\u279d'}{' '}
                    <span style={{ color: '#f9cc04' }}>v{versionData.to}</span>
                </div>

                <ChangelogArea releaseNotesData={releaseNotesData} loading={loading} />

                <Button variant="primary" className="w-full mt-4" onClick={() => onClose(true, false)}>
                    Download
                </Button>
            </div>
        </CrossPlatformDialog>
    )
}

function ChangelogArea({ releaseNotesData, loading }: { releaseNotesData: any; loading: boolean }) {
    return (
        <div className="h-[240px] rounded-[32px] pl-8 pr-2 py-5 bg-white/5 overflow-hidden">
            <div className="overflow-y-auto pr-6 h-full">
                <div className="pb-2">What changed:</div>
                {releaseNotesData &&
                    !loading &&
                    releaseNotesData.map((obj: any) => {
                        const { version, text } = obj
                        return <ChangelogRow key={version} version={version} text={text} />
                    })}
            </div>
        </div>
    )
}

function ChangelogRow({ version, text }: { version: string; text: string }) {
    return (
        <div className="mb-3">
            <pre
                style={{
                    fontSize: '13px',
                    fontFamily: 'sans-serif',
                    margin: 0,
                    fontWeight: 'bold',
                }}
            >
                {version}
            </pre>
            <pre
                style={{
                    fontFamily: 'sans-serif',
                    margin: 0,
                    whiteSpace: 'pre-wrap',
                    marginLeft: '10px',
                }}
            >
                {text}
            </pre>
        </div>
    )
}

export default AppUpdateNotificationPopup
